import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { Address } from './address';

export class Name {
    constructor(doc)
    {
		this.label = null;
		this.firstName = null;
		this.lastName = null;
		this.middleName = null;
		this.suffixName = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.firstName = x.getStringElement(doc, "./ns:FirstName");
		this.lastName = x.getStringElement(doc, "./ns:LastName");
		this.middleName = x.getStringElement(doc, "./ns:MiddleName");
		this.suffixName = x.getStringElement(doc, "./ns:SuffixName");
   }

	 GetName() {
		if (!this.name) return "";
		var n = this.name.firstName;
		n = h.addWithSpace(n, this.name.middleName);
		n = h.addWithSpace(n, this.name.lastName);
		n = h.addWithSpace(n, this.name.suffixName);
		return n;
	 }
}

export class Individual {
    constructor(doc)
    {
		this.label = null
		this.name = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:NAME");
		if (node !== null)
				this.name = new Name(node);
   }

	 GetIndividualName() {
		if (!this.name) return "";
		var n = this.name.firstName;
		n = h.addWithSpace(n, this.name.middleName);
		n = h.addWithSpace(n, this.name.lastName);
		n = h.addWithSpace(n, this.name.suffixName);
		return n;
	 }
}

export class Contact {
    constructor(doc)
    {
		this.label = null
		this.name = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:NAME");
		if (node !== null)
				this.name = new Name(node);
   }

	 GetName() {
		if (this.name === null) return "";
		return this.name.GetName();
	 }
}

export class LegalEntityDetail {
    constructor(doc)
    {
		this.label = null
		this.fullName = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.fullName = x.getStringElement(doc, "./ns:FullName");
   }
}

export class LegalEntity {
    constructor(doc)
    {
		this.label = null
		this.contacts = []
		this.legalEntityDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:CONTACTS/ns:CONTACT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.contacts.push(new Contact(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:LEGAL_ENTITY_DETAIL");
		if (node !== null)
				this.legalEntityDetail = new LegalEntityDetail(node);
   }

	 GetName() {
		let name = this.legalEntityDetail.fullName;
		if (name) return name;
		if (this.contacts.length === 0) return "";
		var contact = this.contacts[0];
		return contact.GetName();
	 }
}

export class AppraiserDetail {
    constructor(doc)
    {
		this.label = null
		this.appraisalSubCommitteeAppraiserIdentifier = null
		this.appraiserCompanyName = null
		this.appraiserEmploymentType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.appraisalSubCommitteeAppraiserIdentifier = x.getStringElement(doc, "./ns:AppraisalSubCommitteeAppraiserIdentifier");
		this.appraiserCompanyName = x.getStringElement(doc, "./ns:AppraiserCompanyName");
		this.appraiserEmploymentType = x.getStringElement(doc, "./ns:AppraiserEmploymentType");
   }
}

export class AppraiserIdentifier {
    constructor(doc)
    {
		this.label = null
		this.agencyAppraiserIdentifier = null
		this.agencyAppraiserIdentifierType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.agencyAppraiserIdentifier = x.getStringElement(doc, "./ns:AgencyAppraiserIdentifier");
		this.agencyAppraiserIdentifierType = x.getStringElement(doc, "./ns:AgencyAppraiserIdentifierType");
   }
}

export class Designation {
    constructor(doc)
    {
		this.label = null
		this.appraiserDesignationType = null
		this.appraiserDesignationTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.appraiserDesignationType = x.getStringElement(doc, "./ns:AppraiserDesignationType");
		this.appraiserDesignationTypeOtherDescription = x.getStringElement(doc, "./ns:AppraiserDesignationTypeOtherDescription");
   }
}

export class Appraiser {
    constructor(doc)
    {
		this.label = null
		this.appraiserDetail = null
		this.appraiserIdentifiers = []
		this.designations = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:APPRAISER_DETAIL");
		if (node !== null)
				this.appraiserDetail = new AppraiserDetail(node);
		nodes = x.selectNodes(doc, "./ns:APPRAISER_IDENTIFIERS/ns:APPRAISER_IDENTIFIER");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.appraiserIdentifiers.push(new AppraiserIdentifier(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:DESIGNATIONS/ns:DESIGNATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.designations.push(new Designation(xn));
			});
		}
   }
}

export class PropertyDataCollector {
    constructor(doc)
    {
		this.label = null
		this.primaryOccupationType = null
		this.primaryOccupationTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.primaryOccupationType = x.getStringElement(doc, "./ns:PrimaryOccupationType");
		this.primaryOccupationTypeOtherDescription = x.getStringElement(doc, "./ns:PrimaryOccupationTypeOtherDescription");
   }
}

export class ProvidedService {
    constructor(doc)
    {
		this.label = null
		this.feeType = null
		this.providedServiceActualCostAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.feeType = x.getStringElement(doc, "./ns:FeeType");
		this.providedServiceActualCostAmount  = x.getMISMOAmountElement(doc, "./ns:ProvidedServiceActualCostAmount");
   }
}

export class ServiceProvider {
    constructor(doc)
    {
		this.label = null
		this.providedServices = []
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:PROVIDED_SERVICES/ns:PROVIDED_SERVICE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.providedServices.push(new ProvidedService(xn));
			});
		}
   }
}

export class AppraiserLicense {
    constructor(doc)
    {
		this.label = null
		this.appraiserLicenseType = null
		this.appraiserLicenseTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.appraiserLicenseType = x.getStringElement(doc, "./ns:AppraiserLicenseType");
		this.appraiserLicenseTypeOtherDescription = x.getStringElement(doc, "./ns:AppraiserLicenseTypeOtherDescription");
   }
}

export class LicenseDetail {
    constructor(doc)
    {
		this.label = null
		this.licenseExpirationDate = null
		this.licenseIdentifier = null
		this.licenseIssuingAuthorityStateCode = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.licenseExpirationDate = x.getMISMODateElement(doc, "./ns:LicenseExpirationDate");
		this.licenseIdentifier = x.getStringElement(doc, "./ns:LicenseIdentifier");
		this.licenseIssuingAuthorityStateCode = x.getStringElement(doc, "./ns:LicenseIssuingAuthorityStateCode");
   }
}

export class License {
    constructor(doc)
    {
		this.label = null
		this.appraiserLicense = null
		this.licenseDetail = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:APPRAISER_LICENSE");
		if (node !== null)
				this.appraiserLicense = new AppraiserLicense(node);
		node = x.selectSingleNode(doc, "./ns:LICENSE_DETAIL");
		if (node !== null)
				this.licenseDetail = new LicenseDetail(node);
   }

	 GetLicenseType() {
		return h.descriptionOrOther(this.appraiserLicense.appraiserLicenseType, this.appraiserLicense.appraiserLicenseTypeOtherDescription);
	 }
}

export class RoleDetail {
    constructor(doc)
    {
		this.label = null
		this.roleType = null
		this.roleTypeAdditionalDescription = null
		this.roleTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.roleType = x.getStringElement(doc, "./ns:PartyRoleType");
		this.roleTypeAdditionalDescription = x.getStringElement(doc, "./ns:PartyRoleTypeAdditionalDescription");
		this.roleTypeOtherDescription = x.getStringElement(doc, "./ns:PartyRoleTypeOtherDescription");
   }
}

export class Role {
    constructor(doc)
    {
		this.label = null;
		this.appraiser = null;
		this.propertyDataCollector = null;
		this.serviceProvider = null;
		this.license = null;
		this.roleDetail = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:APPRAISER");
		if (node !== null)
				this.appraiser = new Appraiser(node);
		node = x.selectSingleNode(doc, "./ns:PROPERTY_DATA_COLLECTOR");
		if (node !== null)
				this.propertyDataCollector = new PropertyDataCollector(node);
		node = x.selectSingleNode(doc, "./ns:SERVICE_PROVIDER");
		if (node !== null)
				this.serviceProvider = new ServiceProvider(node);
		node = x.selectSingleNode(doc, "./ns:LICENSES/ns:LICENSE");
		if (node !== null)
			this.license = new License(node);
		node = x.selectSingleNode(doc, "./ns:ROLE_DETAIL");
		if (node !== null)
				this.roleDetail = new RoleDetail(node);
   }

	GetAppraiserCompany() {
			let company = '';
			if (this.appraiser !== null) {
					company = this.appraiser.appraiserDetail.appraiserCompanyName;
			}
			return company;
	}

	// Get the occupation
	GetOccupation() {
			return h.descriptionOrOther(this.primaryOccupationType, this.primaryOccupationOtherDescription);
	}

	// Get the description
	GetDescription() {
			if (this.roleDetail == null) return '';
			return this.roleDetail.roleTypeAdditionalDescription;
	}

	// Get the role type
	GetRoleType() {
			return h.descriptionOrOther(this.roleDetail.roleType, this.roleDetail.roleTypeOtherDescription);
	}

	
}

export class Party {
    constructor(doc)
    {
		this.label = null;
		this.individual = null;
		this.legalEntity = null;
		this.address = null;
		this.roles = [];

		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:INDIVIDUAL");
		if (node !== null)
				this.individual = new Individual(node);
		node = x.selectSingleNode(doc, "./ns:LEGAL_ENTITY");
		if (node !== null)
				this.legalEntity = new LegalEntity(node);
		node = x.selectSingleNode(doc, "./ns:ADDRESSES/ns:ADDRESS");
		if (node !== null)
				this.address = new Address(node);
		nodes = x.selectNodes(doc, "./ns:ROLES/ns:ROLE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.roles.push(new Role(xn));
			});
		}
  }

	GetName() {
		var name = "";
		if (this.legalEntity)
			name = this.legalEntity.GetName();
		if (h.isEmpty(name) && this.individual)
			name = this.individual.GetIndividualName();
		return name;
	}

	GetIndividualName() {
		var n = "";
		if (!this.individual) return n;
		return this.individual.GetIndividualName();
	}

	GetFullName() {
		var company = "";
		if (!this.legalEntity) {
				let role = this.GetRole("Appraiser");
				if (!role) role = this.GetRole("AppraiserSupervisor");
				if (role) company = role.GetAppraiserCompany();
		} else {
			company = this.legalEntity.legalEntityDetail.fullName;
		}
		return company;
	}

	GetCompanyName() {
		if (this.legalEntity && this.legalEntity.legalEntityDetail.fullName) {
				return this.legalEntity.legalEntityDetail.fullName;
		}

		var company = "";
		let role = this.GetRole("Appraiser");
		if (!role) role = this.GetRole("AppraiserSupervisor");
		if (role) company = role.GetAppraiserCompany();
		return company;
	}

	GetFullAddress() {
			return this.address.GetFullAddress();
	}

	PartyIsRole(roleType) {
			for (const role of this.roles) {
					if (role.roleDetail && role.roleDetail.roleType === roleType) {
							return true;
					}
			}
			return false;
	}

	GetDesignation() {
			for (const pr of this.roles) {
					if (pr.appraiser && pr.appraiser.appraiserDetail.appraiserDesignationType) {
							return h.toEnumText(pr.appraiser.appraiserDetail.appraiserDesignationType);
					}
			}
			return "";
	}

	GetRoleTypes() {
			let roles = "";
			for (const role of this.roles) {
					if (role.roleDetail) {
							roles = h.addWithSpacer(roles, role.GetRoleType(), "/");
					}
			}
			return roles;
	}

	GetRole(type) {
			for (const role of this.roles) {
					if (role.roleDetail && role.roleDetail.roleType === type) {
							return role;
					}
			}
			return null;
	}

	GetRoleLabel() {
			for (const role of this.roles) {
					if (role.label) return role.label;
			}
			return null;
	}

	GetLicense() {
			for (const role of this.roles) {
					if (role.license) return role.license;
			}
			return null;
	}

	GetAppraiser() {
			for (const role of this.roles) {
					if (role.appraiser) return role.appraiser;
			}
			return null;
	}

	GetOccupation() {
			for (const role of this.roles) {
					if (role.roleDetail && role.roleDetail.roleType === "PropertyDataCollector") {
							return role.GetOccupation();
					}
			}
			return null;
	}
}

export class Parties {
    constructor(doc) {
        this.partyList = [];

        const parties = x.selectNodes(doc, './ns:PARTIES/ns:PARTY');
        if (parties) {
            parties.forEach((party) => {
                this.partyList.push(new Party(party));
            });
        }
    }

    GetPartiesOfRole(roleType) {
        const parties = [];
        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
										//console.log("pl: ", role);
                    if (role.roleDetail && role.roleDetail.roleType === roleType) {
                        parties.push(party);
                        break;
                    }
                }
            }
        }
        return parties;
    }

    GetNamesOfPartiesOfRole(roleType) {
        const parties = [];
        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
										//console.log("pl: ", role);
                    if (role.roleDetail && role.roleDetail.roleType === roleType) {
                        var name = party.GetName();
												parties.push(name);
                        break;
                    }
                }
            }
        }
        return parties;
    }

    GetPropertyOwnerName() {
        let names = "";
        const currentOwners = this.GetPartiesOfRole("PropertyOwner");
        if (currentOwners.length > 0) {
            for (const owner of currentOwners) {
							let name = owner.GetName();
							names = h.addWithNewline(names, name);
            }
        }
        return names;
    }

    GetPartyOfRole(roleType) {
        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.roleDetail && role.roleDetail.roleType === roleType) {
                        return party;
                    }
                }
            }
        }

        return null;
    }

    GetRoleByRoleLabel(label) {
        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.label === label) {
                        return role;
                    }
                }
            }
        }
        return null;
    }

    GetPartyByRoleLabel(label) {
        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.label === label) {
                        return party;
                    }
                }
            }
        }
        return null;
    }

		GetPartiesOtherThanRoles(roleNames) {
        const parties = [];

        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.roleDetail && !roleNames.includes(role.roleDetail.roleType)) {
                        parties.push(party);
                        break;
                    }
                }
            }
        }

        return parties;
    }

    GetPartiesInRoles(roleNames) {
        const parties = [];

        if (this.partyList.length > 0) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.roleDetail && roleNames.includes(role.roleDetail.roleType)) {
                        parties.push(party);
                        break;
                    }
                }
            }
        }

        return parties;
    }

    GetFee(feeType) {
            for (let party of this.partyList) {
							for (let role of party.roles) {
								if (role.serviceProvider !== null) {
									for (let ps of role.serviceProvider.providedServices) {
										if (ps.feeType === feeType) {
											return ps.providedServiceActualCostAmount.ToDollarAmount();
										}
									}
								}
							}
						}
        return null;
    }

    PartiesContainRole(roleName) {
        if (this.partyList) {
            for (const party of this.partyList) {
                for (const role of party.roles) {
                    if (role.roleDetail && role.roleDetail.roleType === roleName) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}

